import { FC, useState } from 'react';

import GetHelpModal from 'dibs-contact-1stdibs/exports/GetHelpModal';
import { AuthModalProps } from 'dibs-contact-1stdibs/exports/GetHelpModal';
import { getBuyerSearchParamsProps } from 'dibs-contact-1stdibs/exports/getSearchParamsProps';
import replaceSearchParam from 'dibs-contact-1stdibs/exports/replaceSearchParam';
import authModalLoader from 'dibs-buyer-layout/src/utils/AuthModalLoader';
import { handleLocaleUrl, GLOBAL_CLIENT_ONLY_LOCALE } from 'dibs-intl/exports/urls';

import { Spinner } from 'dibs-elements/exports/Spinner';

import styles from './GetHelpEmbeddedWrapper.scss';

const GetHelpEmbeddedWrapper: FC = () => {
    const [modalProps, setModalProps] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const showAuthModal = async (props: AuthModalProps): Promise<void> => {
        setIsLoading(true);

        const { userId } = await authModalLoader.show({
            action: authModalLoader.constants.LOGIN,
            flow: props.isChatFlow ? authModalLoader.constants.CONTACT_1STDIBS_FLOW : '',
            ga: { label: 'support chat' },
        });

        setIsLoading(false);

        if (userId) {
            if (props.channel === 'liveChat') {
                replaceSearchParam('channel')('liveChat');
                window.location.reload();
            } else {
                setModalProps(props);
            }
        }
    };

    if (isLoading) {
        return <Spinner containerClass={styles.spinner} />;
    }

    return (
        <GetHelpModal
            placement="buyerContactLanding"
            onHelpTypeChange={replaceSearchParam('helpType')}
            onOrderIdChange={replaceSearchParam('orderId')}
            onTopicChange={replaceSearchParam('topic')}
            showAuthModal={showAuthModal}
            {...getBuyerSearchParamsProps()}
            {...modalProps}
            isEmbedded
            onClose={() => {
                window.location.href = handleLocaleUrl('/', GLOBAL_CLIENT_ONLY_LOCALE);
            }}
        />
    );
};

export default GetHelpEmbeddedWrapper;
